'use client';
import dynamic from 'next/dynamic';
import VoiceRingFallback from './VoiceRingFallback';

type SessionMode = 'idle' | 'connecting' | 'listening' | 'speaking' | 'ended';

interface VoiceRingCTAProps {
  size?: number;
  onClick?: () => void;
  className?: string;
  /** When true, mic icon turns red (#ef4444) and outline/border suppressed */
  isActive?: boolean;
  /** Current session mode — drives the label text */
  sessionMode?: SessionMode;
}

// Lazy-load the three.js-heavy inner component so `three` is NOT pulled into the
// initial homepage JS bundle. While the animated ring chunk loads, render no
// still image; the static fallback is reserved for true WebGL failure inside
// VoiceRingCTAInner.
const VoiceRingCTAInner = dynamic(() => import('./VoiceRingCTAInner'), {
  ssr: false,
  loading: () => null,
});

export default function VoiceRingCTA(props: VoiceRingCTAProps) {
  return <VoiceRingCTAInner {...props} />;
}

// Re-export the SVG fallback so any consumer that wants an SSR-safe version
// without the WebGL chunk can still import it from this canonical path.
export { VoiceRingFallback };
